import React, { useCallback } from "react";
import { FlatList } from "react-native";
import { Box, TouchableBox } from "./AHTheme/Box";
import { useLayoutContext } from "./LayoutProvider";
import { useTheme } from "./AHTheme/AHTheme";
import { AHText } from "./Text/AHText";

type FilterItemType = {
  label: string;
  selected: boolean;
};

function FilterItem<T extends FilterItemType>({
  item,
  onPressFilter,
}: {
  item: T;
  onPressFilter: (filter: T) => void;
}) {
  const layout = useLayoutContext();

  return (
    <TouchableBox
      onPress={() => {
        onPressFilter(item);
      }}
      spaceRight="xsmall"
      hitSlop={{ top: 20, bottom: 10 }}
    >
      <Box
        spaceHorizontal="medium"
        borderColor={item.selected ? "primary" : "border-primary"}
        style={{
          borderWidth: 1,
          height: layout.circle.medium,
          borderRadius: layout.circle.medium / 2,
          alignItems: "center",
          justifyContent: "center",
        }}
        color={item.selected ? "primary" : "surface"}
      >
        <AHText
          type="subtitle"
          color={item.selected ? "text-inverted" : "text-washed"}
        >
          {item.label}
        </AHText>
      </Box>
    </TouchableBox>
  );
}

export function LegacyFilter<T extends FilterItemType>({
  filters,
  onPressFilter,
  ListFooterComponent,
}: {
  filters: T[];
  onPressFilter: (filter: T) => void;
  ListFooterComponent?: React.ReactElement;
}) {
  const theme = useTheme();
  const layout = useLayoutContext();

  const renderItem = useCallback(
    ({ item }: { item: T }) => {
      return <FilterItem item={item} onPressFilter={onPressFilter} />;
    },
    [onPressFilter]
  );

  return (
    <Box
      style={{ flexDirection: "row", alignItems: "center" }}
      color="surface-primary"
    >
      <FlatList
        data={filters}
        horizontal
        contentContainerStyle={{
          paddingVertical: layout.space.small,
          paddingLeft: layout.space.medium,
          paddingRight: layout.space.small + layout.space.xsmall,
          backgroundColor: theme.surface,
        }}
        showsHorizontalScrollIndicator={false}
        renderItem={renderItem}
        ListFooterComponent={ListFooterComponent}
      />
    </Box>
  );
}
